/**
 * Locales the bundle ships translations for. Matches the legacy storefront
 * locales (DE + EN + FR + IT + NL) plus ES which the v3 admin added.
 */
export type Locale = 'de_DE' | 'en_US' | 'fr_FR' | 'es_ES' | 'it_IT' | 'nl_NL';

export const SUPPORTED_LOCALES: ReadonlyArray<Locale> = ['de_DE', 'en_US', 'fr_FR', 'es_ES', 'it_IT', 'nl_NL'];
export const DEFAULT_LOCALE: Locale = 'en_US';
